import React, { PureComponent } from 'react'
import {
  Card,
  CardHeader,
  CardBody,
  InputGroup,
  Input,
  InputGroupAddon
} from 'reactstrap'

class UserSearch extends PureComponent {
  static defaultProps = {
    headerMessage: 'Search Users by Username or Email',
    placeholder: 'joesmith'
  }
  constructor(props) {
    super(props)
    this.state = {
      query: ''
    }

    this.onQueryInput = this.onQueryInput.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
  }

  componentDidMount() {
    document.querySelector('#user-search-input').focus()
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      this.onSearch()
    }
  }

  onQueryInput(e) {
    this.setState({ query: e.target.value })
  }

  onSearch() {
    if (this.state.query.length) {
      this.props.onSearch(this.state.query)
    }
  }

  render() {
    return (
      <Card>
        <CardHeader>{this.props.headerMessage}</CardHeader>
        <CardBody>
          <InputGroup>
            <Input
              type="search"
              id="user-search-input"
              placeholder={this.props.placeholder}
              value={this.state.query}
              onKeyPress={this.onKeyPress}
              onChange={this.onQueryInput}
            />
            <InputGroupAddon className="miami" onClick={this.onSearch}>
              <i className="icon-magnifier" />Search
            </InputGroupAddon>
          </InputGroup>
        </CardBody>
      </Card>
    )
  }
}

export default UserSearch



// WEBPACK FOOTER //
// ./src/views/Pages/Users/UserSearch.js